import { render } from "./myMemberInfo.vue?vue&type=template&id=63bc36ea&scoped=true"
import script from "./myMemberInfo.vue?vue&type=script&lang=js"
export * from "./myMemberInfo.vue?vue&type=script&lang=js"

import "./myMemberInfo.vue?vue&type=style&index=0&id=63bc36ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bc36ea"]])

export default __exports__